const colors = {
  text: {
    default: "#8E8279",
    body: "#666",
    alt: "#999",
    reverse: "#FFF"
  },
  bg: {
    default: "#FFF",
    alt: "#E6E6E6",
    wash: "#F7F7F7",
    reverse: "#000"
  },
  brand: {
    blue: "#25CAD3",
    yellow: "#FFD923",
    pink: "#E7417A",
    orange: "#F38A00",
    green: "#72A84F",
    purple: "#6D3A5D",
    olive: "#737335",
    gray: "#8E8279"
  }
};

const space = [0, 4, 8, 16, 24, 32, 48, 64, 96, 128];

const fontSizes = [14, 16, 19, 24, 32, 48, 64];

const fonts = {
  sans: `'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;`,
  serif: `Georgia, 'Times New Roman', Times, serif`,
  mono: `monospace`
};

const theme = {
  colors,
  space,
  fontSizes,
  fonts
};

export default theme;
